import { render } from "./DataSourceLabels.vue?vue&type=template&id=92a8d66e&ts=true"
import script from "./DataSourceLabels.vue?vue&type=script&lang=ts"
export * from "./DataSourceLabels.vue?vue&type=script&lang=ts"

import "./DataSourceLabels.vue?vue&type=style&index=0&id=92a8d66e&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__